import React from "react";
import TextFieldProps from '../../../types/TextField.type';
import { TextField } from '@mui/material';

 const DispatcherNotesField: React.FC<TextFieldProps> = ({ notes, setNotes }) => {
    return (
     <TextField
        label="Dispatcher Notes"
        multiline
        rows={14}
        value={notes}
        onChange={(e) => setNotes(prevNotes => ({ ...prevNotes, Notes: e.target.value }))}
        variant="outlined"
        sx={{ 
            backgroundColor: '#FFFFFF',
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: '#91898f', // Default border color
                },
                width: '50vw',
            },
            '& .MuiInputBase-input': {
                fontSize: '12px',
                fontFamily: 'AS Circular',
            },
         }}
         slotProps={{
            input: {
                style: {
                    fontSize: '15px', // Set the desired font size
                    fontFamily: 'AS Circular', // Set the desired font family
                }
            },
        }}
    />
    
    );
};

export default DispatcherNotesField;

